import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {getInputClassName, getSessionStorage, setSessionStorage} from "../../../../../CommonFunctions";
import {EMAIL_REGEX, PHONE_REGEX} from "@falcon/services";

interface IProps {
    showModal: boolean;
    onHide: () => void;
    onChangeAccountDetails: (contactDetails: {email: string, phoneNumber: string, showPopup: boolean}) => void;
}

interface IChangeContactDetailsPopupState {
    contactDetails: IContactDetails;
}

interface IContactDetails {
    phoneNumber: string;
    email: string;
    isPhoneNumberValid: boolean;
    isEmailValid: boolean;
    invalidPhoneNumberErrorMessage: string;
    invalidEmailErrorMessage: string;
}

export class ChangeContactDetailsPopup extends React.Component<IProps, IChangeContactDetailsPopupState> {

    constructor(props: IProps) {
        super(props);

        const contactDetails: IContactDetails = getSessionStorage("contactDetails");

        this.state = {
            contactDetails: contactDetails !== null ? contactDetails : {
                phoneNumber: "",
                email: "",
                isPhoneNumberValid: true,
                isEmailValid: true,
                invalidPhoneNumberErrorMessage: "",
                invalidEmailErrorMessage: ""
            }
        }
    }

    public render() {
        const {contactDetails} = this.state;

        return (
            <React.Fragment>
                <Modal className="my-2 info-modal" isOpen={this.props.showModal} toggle={this.handleOnClose} backdrop="static">
                    <ModalHeader toggle={this.handleOnClose}>
                        <div className="d-flex">
                            <div className="text-blue-2 font-weight-medium">Check contact details</div>
                        </div>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        <p className="mt-2 mb-2">
                            Please enter a mobile number and email address you would like us to contact on regarding this claim.
                            Your changes will not update your Allianz account contact details
                        </p>
                        <div className="form-group text-center">
                            <label htmlFor="mobile" className="font-weight-semi-bold">{!contactDetails.isPhoneNumberValid ?
                                this.renderErrorMessage(contactDetails.invalidPhoneNumberErrorMessage) : "Phone number"}</label>
                            <div className="input-group m-auto">
                                <input type="text" className={getInputClassName(contactDetails.isPhoneNumberValid)} id="mobile" value={contactDetails.phoneNumber}
                                       onChange={this.handleChange}/>
                            </div>
                        </div>
                        <div className="form-group text-center">
                            <label htmlFor="email" className="font-weight-semi-bold">{!contactDetails.isEmailValid ?
                                this.renderErrorMessage(contactDetails.invalidEmailErrorMessage) : "Email address"}</label>
                            <div className="input-group m-auto">
                                <input type="text" className={getInputClassName(contactDetails.isEmailValid)} id="email" value={contactDetails.email}
                                       onChange={this.handleChange}/>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className="d-inline-block">
                        <div className="form-group">
                            <button type="button" className="btn btn-primary btn-blue-dashboard w-100" onClick={this.handleAccountDetailsChange} id="updateContactInformation"
                                    disabled={!this.isFormValid()}>
                                Change contact details
                            </button>
                        </div>
                        <div className="form-group">
                            <button type="button" className="btn btn-white-dashboard w-100"
                                    onClick={this.handleOnClose} id="cancelChanges">
                                Cancel
                            </button>
                        </div>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }

    private isFormValid = (): boolean => {
        const contactDetails: IContactDetails = {...this.state.contactDetails};
        return contactDetails.isEmailValid && contactDetails.isPhoneNumberValid && contactDetails.email !== "" && contactDetails.phoneNumber !== "";
    };

    private handleAccountDetailsChange = (event: any): void => {
        if (event.target.disabled) {
            event.preventDefault();
        } else {
            const item: any = {
                email: this.state.contactDetails.email,
                phoneNumber: this.state.contactDetails.phoneNumber,
                showPopup: false
            };
            this.props.onChangeAccountDetails(item);
            this.resetState();
        }
    };

    private handleOnClose = (): void => {
        this.resetState();
        this.props.onHide();
    };

    private resetState = (): void => {
        const contactDetails: IContactDetails = {...this.state.contactDetails};
        contactDetails.phoneNumber = "";
        contactDetails.email = "";
        contactDetails.isEmailValid = true;
        contactDetails.isPhoneNumberValid = true;
        contactDetails.invalidPhoneNumberErrorMessage = "";
        contactDetails.invalidEmailErrorMessage = "";
        this.setState({contactDetails});
        setSessionStorage("contactDetails", contactDetails);
    };

    private handleChange = (event: any): void => {
        event.preventDefault();
        const { id, value } = event.target;
        const contactDetails: IContactDetails = {...this.state.contactDetails};

        switch (id) {
            case "email":
                contactDetails.email = value;
                contactDetails.isEmailValid = EMAIL_REGEX.test(value);
                contactDetails.invalidEmailErrorMessage = !contactDetails.isEmailValid ? "Invalid email address" : "Phone number";
                this.setState({contactDetails});
                setSessionStorage("contactDetails", contactDetails);
                break;
            case "mobile":
                contactDetails.phoneNumber = value;
                contactDetails.isPhoneNumberValid = PHONE_REGEX.test(value);
                contactDetails.invalidPhoneNumberErrorMessage = !contactDetails.isPhoneNumberValid ? "Invalid UK mobile phone number" : "Email address";
                this.setState({contactDetails});
                setSessionStorage("contactDetails", contactDetails);
                break;
            default:
                break;
        }
    };

    private renderErrorMessage = (message: string) => {
        return (<label className="text-red">{message}</label>)
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/motor/motorClaims/ChangeContactDetailsPopup.tsx